/** Convierte keys camelCase de la API a snake_case para compatibilidad con tipos existentes */
export function toSnakeCase<T = unknown>(obj: unknown): T {
  if (obj === null || obj === undefined) return obj as T;
  if (Array.isArray(obj)) return obj.map(toSnakeCase) as T;
  if (typeof obj !== 'object') return obj as T;
  if (obj instanceof Date) return obj as T;

  return Object.entries(obj as Record<string, unknown>).reduce(
    (acc, [key, value]) => {
      const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
      acc[snakeKey] = toSnakeCase(value);
      return acc;
    },
    {} as Record<string, unknown>,
  ) as T;
}

/** Convierte keys snake_case a camelCase para enviar a la API */
export function toCamelCase<T = unknown>(obj: unknown): T {
  if (obj === null || obj === undefined) return obj as T;
  if (Array.isArray(obj)) return obj.map(toCamelCase) as T;
  if (typeof obj !== 'object') return obj as T;
  if (obj instanceof Date) return obj as T;

  return Object.entries(obj as Record<string, unknown>).reduce(
    (acc, [key, value]) => {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      acc[camelKey] = toCamelCase(value);
      return acc;
    },
    {} as Record<string, unknown>,
  ) as T;
}
